$(function() {
    var $configurator = $('#simple-configurator');
    var $addToCartBottom = $('.addToCartBottomSection');
    let locales = getLang();

    if (!$configurator.length) {
        return;
    }
    var $requestStatisticSettings = $configurator.attr('request-statistic-settings') ? JSON.parse($configurator.attr('request-statistic-settings')) : [];
    var $requestStatisticId = crypto.getRandomValues(new Uint8Array(16)).join('');
    var $total = $configurator.find('[data-price=total]')
        .add($addToCartBottom.find('[data-price=total]'));
    var $totalForRegularCustomer = $configurator.find('[data-price=total-regular-price]')
        .add($addToCartBottom.find('[data-price=total-regular-price]'));
    var $totalWithoutTax = $configurator.find('[data-price=totalWithoutTax]')
        .add($addToCartBottom.find('[data-price=totalWithoutTax]'));
    var $item = $configurator.find('[data-price=item]')
        .add($addToCartBottom.find('[data-price=item]'));
    var $discountValue = $configurator.find('[data-price=discountValue]')
        .add($addToCartBottom.find('[data-price=discountValue]'));
    var $discount = $configurator.find('[data-price=discount]')
        .add($addToCartBottom.find('[data-price=discount]'));
    var $ordinary = $configurator.find('[data-price=ordinary]')
        .add($addToCartBottom.find('[data-price=ordinary]'));
    var $regularDiscount = $configurator.find('[data-price=regular-discount]')
        .add($addToCartBottom.find('[data-price=regular-discount]'));
    var $regularOrdinary = $configurator.find('[data-price=regular-ordinary]')
        .add($addToCartBottom.find('[data-price=regular-ordinary]'));
    var $quantity = $configurator.find('[data-model=quantity]');
    var $miniCartQuantity = $configurator.find('[data-model="mini-cart-quantity"]');
    var product = $configurator.attr('data-product');
    var config = $configurator.attr('data-configuration');
    var edit = $configurator.attr('data-edit');
    var $sidesSelect = $configurator.find('select.sides');

    var $priceUnit = $configurator.find('.price-unit');
    var $buyButton = $('.simple-product__buy-button');
    var $drawing = $('.icc-glass-railing-draw-wrapper.icc-draw');
    var $accessoriesList = $('#simpleConfiguratorAccessories2');
    var $seriesList = $('#simpleConfiguratorSeries');
    var configData = {};
    var getPrice = false;
    var price = 0;
    var regularCustomerPrice = 0;
    var netPrice = 0;
    var discount = 0;
    var discountValueForRegularCustomer = 0;
    var netDiscount = 0;
    var discountValue = 0;
    var locks = {
        stock: false,
        subProducts: false,
    };
    const TYPE_POLE_STRAIGHT_ID = 1;
    const TYPE_POLE_CORNER_ID = 2;
    const TYPE_POLE_END_ID = 3;
    const TYPE_WALL_FIXTURE_GLASS_ID = 9;

    const POLE_MARGIN_IN_MM = 50;
    const WALL_FIXTURE_MARGIN_IN_MM = 25;

    $('.load').addClass('hidden');

    function setQuantityInput(quantity)
    {
        $quantity.val(quantity);
        $miniCartQuantity.val(quantity);

        if (configData.data) {
            configData.data[0].attributes.quantity = quantity;
        } else {
            console.error('Cannot change quantity, product configuration is not initialized yet');
        }
    }

    function unlockAllPoleChoices()
    {
        $(`.glassRailingSideSetting[data-side-number]`).find('option').each(function(optionIndex, poleOption) {
            $(poleOption).prop('disabled', false);
        });
    }

    function fixPoleChoiceForSide(sideNumber)
    {
        const sidesNumber = Number($sidesSelect.val());
        const sideElement = $(`.glassRailingSideSetting[data-side-number=${sideNumber}]`);
        const startPoleSelect = sideElement.find('select.startPole');
        const endPoleSelect = sideElement.find('select.endPole');
        const defaultEndPoleId = configData.data[0].attributes.defaultEndPoleId;

        const isSelectedStartOptionBlocked = startPoleSelect.find(':selected').prop('disabled');
        const firstAvailableStartOptionId = startPoleSelect.children('option:enabled').eq(0).attr('value');

        if (isSelectedStartOptionBlocked) {
            startPoleSelect.val(firstAvailableStartOptionId);
            startPoleSelect.change();
        }

        const isSelectedEndOptionBlocked = endPoleSelect.find(':selected').prop('disabled');
        const firstAvailableEndOptionId = configData.data[0].attributes.defaultCornerPoleId;

        if (Number(sideNumber) === sidesNumber) {
            if (isSelectedEndOptionBlocked) {
                endPoleSelect.val(defaultEndPoleId);
            }
        } else {
            if (isSelectedEndOptionBlocked) {
                endPoleSelect.val(firstAvailableEndOptionId);
            }
        }
        if (isSelectedEndOptionBlocked) {
            // Recompute the side length for the new pole margin, keeping the selected panels
            endPoleSelect.change();
        }
        updateSideConfiguration(
            sideNumber,
            startPoleSelect.val(),
            endPoleSelect.val(),
            sideElement.find('input.length').val(),
        );
    }

    function getAllSelectedAccessories()
    {
        let selectedAccessoriesDetails = [];

        if (configData.data[0].relationships.accessories.data.length > 0) {
            configData.data[0].relationships.accessories.data.find(function(accessory) {
                const selectedAccessoryDetails = getIncluded('accessory', accessory.id);
                selectedAccessoriesDetails.push(selectedAccessoryDetails);
            });
        }
        return selectedAccessoryDetails;
    }

    function hasHandRailEnabled()
    {
        if (configData.data[0].relationships.accessories.data.length > 0) {
            return configData.data[0].relationships.accessories.data.find(function(accessory) {
                const selectedAccessoryDetails = getIncluded('accessory', accessory.id);

                if (selectedAccessoryDetails.attributes.accessoryType === 1) {
                    return true;
                }
            });
        }
        return false;
    }

    function blockPoleChoices()
    {
        const sidesNumber = Number($sidesSelect.val());
        const isStainlessSteelRailing = configData.data[0].attributes.isStainlessSteelRailing;

        if (typeof sidesNumber === 'undefined') {
            return false;
        }
        unlockAllPoleChoices();

        for (side = 1; side <= sidesNumber; side++) {
            const sideElement = $(`.glassRailingSideSetting[data-side-number=${side}]`);
            const startPoleSelect = sideElement.find('select.startPole');
            const endPoleSelect = sideElement.find('select.endPole');

            if (side === 1) {
                endPoleSelect.parent().parent().removeClass('hide');
                startPoleSelect.find('option').each(function(optionIndex, optionValue) {
                    const poleOption = $(optionValue);
                    const poleOptionTypeId = Number(poleOption.attr('data-type-id'));

                    if (isStainlessSteelRailing) {
                        if (poleOptionTypeId !== TYPE_POLE_END_ID && poleOptionTypeId !== TYPE_WALL_FIXTURE_GLASS_ID) {
                            poleOption.prop('disabled', true);
                            poleOption.attr('title', locales['You need to chose more sides']);
                        } else {
                            poleOption.prop('disabled', false);
                            poleOption.removeAttr('title');
                        }
                    } else {
                        if (poleOptionTypeId !== TYPE_POLE_STRAIGHT_ID) {
                            poleOption.prop('disabled', true);
                        } else {
                            poleOption.prop('disabled', false);
                            poleOption.removeAttr('title');
                        }
                    }
                });
            }
            if (side === sidesNumber) {
                endPoleSelect.parent().parent().removeClass('hide');
                endPoleSelect.find('option').each(function(optionIndex, optionValue) {
                    const poleOption = $(optionValue);
                    const poleOptionTypeId = Number(poleOption.attr('data-type-id'));

                    if (isStainlessSteelRailing) {
                        if (poleOptionTypeId !== TYPE_POLE_END_ID && poleOptionTypeId !== TYPE_WALL_FIXTURE_GLASS_ID) {
                            poleOption.prop('disabled', true);
                            poleOption.attr('title', locales['You need to chose more sides']);
                        } else {
                            poleOption.prop('disabled', false);
                            poleOption.removeAttr('title');
                        }
                    } else {
                        if (poleOptionTypeId !== TYPE_POLE_STRAIGHT_ID) {
                            poleOption.prop('disabled', true);
                            poleOption.attr('title', locales['You need to chose more sides']);
                        } else {
                            poleOption.prop('disabled', false);
                            poleOption.removeAttr('title');
                        }
                    }
                });
            }
            if (side < sidesNumber) {
                endPoleSelect.parent().parent().addClass('hide');
                endPoleSelect.find('option').each(function(optionIndex, optionValue) {
                    const poleOption = $(optionValue);
                    const poleOptionTypeId = Number(poleOption.attr('data-type-id'));

                    if (isStainlessSteelRailing) {
                        if (poleOptionTypeId === TYPE_POLE_END_ID || poleOptionTypeId === TYPE_WALL_FIXTURE_GLASS_ID || poleOptionTypeId === TYPE_POLE_STRAIGHT_ID) {
                            poleOption.prop('disabled', true);
                            poleOption.attr('title', locales['You need to chose more sides']);
                        } else {
                            poleOption.prop('disabled', false);
                            poleOption.removeAttr('title');
                        }
                    } else {
                        if (poleOptionTypeId !== TYPE_POLE_CORNER_ID) {
                            poleOption.prop('disabled', true);
                            poleOption.attr('title', locales['Only corner pole is allowed for this side']);
                        } else {
                            poleOption.prop('disabled', false);
                            poleOption.removeAttr('title');
                        }
                    }
                });
            }

            fixPoleChoiceForSide(side);
        }
    }

    function processAccessoryClick()
    {
        const element = $(this),
            id = Number(element.attr('data-id')),
            index = isAccessorySelected(id);

        // If accessory is default it cannot be removed
        if (Number(element.attr('data-is-default')) === 1) {
            return false;
        }
        // Accessory is already selected
        if (index >= 0) {
            removeAccessory(id);
        } else {
            // Accessory is not available
            if (
                Number(element.attr('data-is-stock')) === 1 &&
                Number(element.attr('data-quantity')) === 0
            ) {
                return false;
            }
            addAccessory(id);
        }
        populateAccessoriesPreview();
        updatePrice();
        updateDrawing();
        updateProductUi();
    }

    $accessoriesList.on('click', '.configuratorOptionCheckboxListingItem', processAccessoryClick);

    function isAccessorySelected(id)
    {
        return configData.data[0].relationships.accessories.data.findIndex(x => x.id === id);
    }

    function removeAllAccessories()
    {
        configData.data[0].relationships.accessories.data = [];

        $('.subProductAdditionalItems')
            .find('.configuratorOptionCheckboxListingItem')
            .removeClass('--checked-item');
    }

    function removeAccessory(id)
    {
        const index = isAccessorySelected(id);

        if (index == -1) {
            return;
        }

        configData.data[0].relationships.accessories.data.splice(index, 1);

        $('.subProductAdditionalItems')
            .find('[data-id=' + id + ']')
            .removeClass('--checked-item');

        // updateStockStatus();
    }

    function addAccessory(id)
    {
        $('.subProductAdditionalItems')
            .find('[data-id=' + id + ']')
            .addClass('--checked-item');

        configData.data[0].relationships.accessories.data.push({
            'id': id,
            'type': 'accessory',
        });

        // updateStockStatus();
    }

    function getIncluded(key, id)
    {
        var result = null;

        configData.included[key].forEach(function(element) {
            if (Number(element.id) === Number(id)) {
                result = element;
            }
        });
        return result;
    }

    function hasSeries()
    {
        if (
            Array.isArray(configData.included.series) &&
            configData.included.series.filter(elem => elem.hiddenSerie != 1).length > 0
        ) {
            return true;
        }
        return false;
    }

    function populateSeries()
    {
        if (!hasSeries()) {
            $seriesList.parent().parent().addClass('--hidden');
            return false;
        }
        $seriesList.parent().parent().removeClass('--hidden');

        configData.included.series.filter(elem => elem.hiddenSerie != 1).forEach(function(serie) {
            let serieBox = $('<div>')
                .addClass('configuratorOptionCardListingItem')
                .addClass('simpleProductSerieListingItem');
            if (serie.id == $seriesList.data('serie-id')) {
                serieBox.addClass('--checked-item');
            }
            serieBox
                .append(
                    $('<div>')
                        .addClass('configuratorOptionCardListingItem__header')
                        .append(
                            $('<div>')
                                .addClass('configuratorOptionCardListingItem__header-name')
                                .text(serie.attributes.name)
                        )
                        .append(
                            $('<div>')
                                .addClass('configuratorOptionCardListingItem__header-price')
                                .text(
                                    serie.id == $seriesList.data('serie-id') ? $seriesList.data('zero-title') : serie.attributes.basePriceDifference.formatted
                                )
                        )
                    )
                .append(
                    $('<div>')
                        .addClass('configuratorOptionCardListingItem__body')
                        .append(
                            $('<p>')
                                .addClass('configuratorOptionCardListingItem__details')
                                .html(serie.attributes.details)
                                .addClass(serie.attributes.details === null ? 'hide' : '')
                        )
                        .append(
                            $('<div>')
                                .addClass('configuratorOptionCardListingItem__btn-group')
                                .append(
                                    $('<a>')
                                        .attr('href', serie.attributes.url)
                                        .append(
                                            $('<button>')
                                                .addClass('configuratorOptionCardListingItem__btn')
                                                .attr('type', 'button')
                                                .text($seriesList.data('btn-text'))
                                        )
                                )
                        )
                );

            $seriesList.append(serieBox);
        });

        $('.simpleProductSerieListingItem').click(function() {
            if (!$(this).hasClass('--checked-item')) {
                if ($(this).hasClass('--opened-item')) {
                    $(this).removeClass('--opened-item');
                } else {
                    $('.simpleProductSerieListingItem').removeClass('--opened-item');
                    $(this).addClass('--opened-item');
                }
            } else {
                $('.simpleProductSerieListingItem').removeClass('--opened-item');
            }
        });
    }

    $('#closeAccessoryDetailsModal').click(function() {
        const modal = $('#accessoryDetailsModal');
        modal.find('.configuratorModal__title').text('');
        modal.find('.modalContent').text('');
        modal.find('.modalImg').attr('src', '');
        modal.addClass('--hiddenTemplateElement');
    });

    $('.configuratorPanel__header').click(function() {
        const elem = $(this).parent();
        if (elem.hasClass('--opened')) {
            elem.removeClass('--opened');
            elem.find('.configuratorPanel__body').removeClass('--active').addClass('--hidden');
        } else {
            elem.addClass('--opened');
            elem.find('.configuratorPanel__body').removeClass('--hidden').addClass('--active');
        }
    });

    function addStatistic(action, data, sendDataFromStore = false){
        var payload = {
            statisticData: data,
            productInfo: configData.productInfo,
            frontendId: $requestStatisticId,
            frontendAction: action,
            _csrfToken: $('meta[name="csrfToken"]').attr('content'),
        };
        if (sendDataFromStore) {
            payload['statisticData'] = {...data, ...configData.data[0]};
        }

        $.ajax({
            url: '/api-statistic/add-frontend-action',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify(payload)
        });
    }

    function getDrawing()
    {
        let svg = $('#icc-balustrada-container svg');
        svg.removeAttr('width');
        svg.removeAttr('height');

        return svg[0].outerHTML;
    }

    function getCurrentPanelWidths()
    {
        if (!configData.data || !configData.data[0] || !configData.data[0].attributes || !configData.data[0].attributes.sidesConfiguration) {
            return [];
        }

        let widths = [];

        configData.data[0].attributes.sidesConfiguration.sides.forEach(function(side) {
            if (!side) {
                return;
            }

            if (Array.isArray(side.sequence) && side.sequence.length > 0) {
                widths = widths.concat(side.sequence.map(Number).filter(function(width) {
                    return Number.isFinite(width);
                }));
                return;
            }

            if (!side.pieces) {
                return;
            }

            Object.entries(side.pieces).forEach(function(entry) {
                const width = Number(entry[0]);
                const quantity = Number(entry[1]);

                if (!Number.isFinite(width) || !Number.isFinite(quantity) || quantity <= 0) {
                    return;
                }

                for (let i = 0; i < quantity; i++) {
                    widths.push(width);
                }
            });
        });

        return widths;
    }

    function hasVisuallyUnbalancedGlassConfiguration()
    {
        const widths = getCurrentPanelWidths();

        if (widths.length === 0) {
            return false;
        }

        const numberOf250Panels = widths.filter(function(width) {
            return width === 250;
        }).length;
        const smallestPanelWidth = Math.min.apply(null, widths);
        const largestPanelWidth = Math.max.apply(null, widths);
        const uniquePanelWidths = new Set(widths).size;
        const hasPanelWidthBelow400 = widths.some(function(width) {
            return width < 400;
        });

        return numberOf250Panels >= 2
            || hasPanelWidthBelow400
            || (smallestPanelWidth > 0 && (largestPanelWidth / smallestPanelWidth) > 3)
            || uniquePanelWidths > 2;
    }

    function showGlassRailingUnbalancedWarning()
    {
        $('.glassRailingConfigurator__unbalancedWarningPopup').css('display', 'flex');
    }

    function hideGlassRailingUnbalancedWarning()
    {
        $('.glassRailingConfigurator__unbalancedWarningPopup').css('display', 'none');
    }

    function saveProduct(skipUnbalancedWarning = false)
    {
        if (!skipUnbalancedWarning && hasVisuallyUnbalancedGlassConfiguration()) {
            showGlassRailingUnbalancedWarning();
            return;
        }

        if ($requestStatisticSettings.includes('addToCart')) {
            addStatistic('addToCartGlassRailing', {confId: configData.data[0].id});
        }
        //block ability to save product before price calculation
        if (!getPrice) {
            false;
        }
        configData.data[0].attributes.drawingConfiguration = buildDrawingConfig();

        var payload = {
            data: [
                configData.data[0],
                {},
                getDrawing()
            ],
            productInfo: configData.productInfo,
            _csrfToken: $('meta[name="csrfToken"]').attr('content'),
        };
        var seriesUpgradeToggle = document.querySelector('[data-series-upgrade-campaign]:checked');
        if (seriesUpgradeToggle) {
            payload.seriesUpgradeCampaignId = Number(seriesUpgradeToggle.value);
        }
        if (editSource.value === 'offer') {
            payload.meta = {
                itemId: $('#itemId').val()
            };
            $.ajax({
                url: apiUrl + '/update-offer-position',
                type: 'POST',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                data: JSON.stringify(payload),
                success: function(response) {
                    const offerId = response.data[0].order_id;
                    if (response.meta.success) {
                        window.location.href = `/shop/offers/employee_summary/${offerId}`;
                    }
                }
            });
        } else {
            if ($requestStatisticSettings.includes('addToCart')) {
                addStatistic('addToCartGlassRailingWithData', {confId: configData.data[0].id}, true);
            }
            if (itemId.value != 0) {
                payload.meta = {
                    itemId: $('#itemId').val()
                };
            }
            $.ajax({
                url: apiUrl + '/add-to-cart',
                type: 'POST',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                data: JSON.stringify(payload),
                success: function(response) {
                    if (response.meta.success) {
                        updateCart(response.data);
                        $('.addedToBasketPopup').addClass('--visible');
                        getAddToCartGTMEvent();
                    }
                }
            });
        }
    }

    function getConfig()
    {
        let url = apiUrl + '/get-product/' + product + '/' + config + ((edit) ? '/' + edit : '');

        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            success: function(response) {
                configData = response;

                setQuantityInput(configData.data[0].attributes.quantity);

                populateAccessories();
                populateSeries();
                populatePoleTypes();
                populateSides();
                populateDefaults(function() {
                    updatePrice();
                    updateDrawing();
                    updateProductUi();
                    setPriceSwitchState();
                });
            }
        });
    }

    function populateDefaults(callback)
    {
        var defaultSidesNumber = configData.data[0].attributes.sidesConfiguration.sides.length;
        var defaultSidesConfiguration = configData.data[0].attributes.sidesConfiguration.sides;

        updateNumberOfSides(defaultSidesNumber, function() {
            var index = 0;
            function processNextSide() {
                if (index >= defaultSidesConfiguration.length) {
                    blockPoleChoices();
                    updatePrice();
                    updateDrawing();
                    updateProductUi();
                    if (callback) callback();
                    return;
                }
                updateSideConfigurationOnUi(defaultSidesConfiguration[index], function() {
                    index++;
                    processNextSide();
                });
            }
            processNextSide();
        });
    }

    function populatePoleTypes()
    {
        const options = configData.included.poleTypes;
        const startPoleSelect = $('.glassRailingSideSetting.--template').find('select.startPole');
        const endPoleSelect = $('.glassRailingSideSetting.--template').find('select.endPole');

        startPoleSelect.empty();
        endPoleSelect.empty();

        options.forEach(function(option) {
            startPoleSelect.append(
                $('<option>')
                    .attr('value', option.id)
                    .attr('data-type-id', option.attributes.typeId)
                    .text(option.attributes.name)
            );
            endPoleSelect.append(
                $('<option>')
                    .attr('value', option.id)
                    .attr('data-type-id', option.attributes.typeId)
                    .text(option.attributes.name)
            );
        });
    }

    function calculateMargin(startPoleId, endPoleId)
    {
        var startPole = getIncluded('poleTypes', startPoleId);
        var endPole = getIncluded('poleTypes', endPoleId);

        var totalMargin = 0;
        var wallFixturesNumber = 0;

        if (startPole !== null && startPole.attributes.typeId === TYPE_WALL_FIXTURE_GLASS_ID) {
            wallFixturesNumber += 1;
        }
        if (endPole !== null && endPole.attributes.typeId === TYPE_WALL_FIXTURE_GLASS_ID) {
            wallFixturesNumber += 1;
        }
        if (wallFixturesNumber === 0) {
            totalMargin = POLE_MARGIN_IN_MM * 2;
        }
        if (wallFixturesNumber === 1) {
            totalMargin = WALL_FIXTURE_MARGIN_IN_MM;
        }
        if (wallFixturesNumber === 2) {
            // Must match GlassRailingPartCalculator::calculateGlassForSide() on the server
            totalMargin = -WALL_FIXTURE_MARGIN_IN_MM * 2;
        }
        return totalMargin;
    }

    function getSelectedSections(sideElement)
    {
        var sections = {};

        sideElement.find('.glassRailingLengthInput').each(function(index, element) {
            sections[$(element).attr('data-length')] = Number($(element).val());
        });

        return sections;
    }

    function calculateClosestLength(userLength, startPoleId, endPoleId, callback, sections)
    {
        var totalMargin = calculateMargin(startPoleId, endPoleId);
        var customerSelectedLength = Number(userLength);
        var lengthToFill = customerSelectedLength - totalMargin;
        var payload = {
            configurationId: config,
            lengthToFill: lengthToFill,
            _csrfToken: $('meta[name="csrfToken"]').attr('content'),
        };

        // The server decides (CMS setting) whether to keep this selection or recalculate it
        if (sections) {
            payload.sections = sections;
        }

        $.ajax({
            url: apiUrl + '/glass-railing/best-combination',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify(payload),
            success: function(result) {
                var closestLength = result.realLengthToFill;
                if (closestLength <= 0) {
                    closestLength = Math.min.apply(null, configData.data[0].attributes.availableLengths);
                }
                closestLength += totalMargin;
                callback({
                    'length': closestLength,
                    'pieces': result.pieces,
                    'sequence': result.sequence || [],
                });
            },
        });
    }

    function populateSides()
    {
        const minSidesNumber = Number(configData.data[0].attributes.minNumberOfSides);
        const maxSidesNumber = Number(configData.data[0].attributes.maxNumberOfSides);

        for (let sideNumber = minSidesNumber; sideNumber <= maxSidesNumber; sideNumber++) {
            $sidesSelect.append(
                $('<option>')
                    .attr('value', sideNumber)
                    .text(sideNumber)
            );
        }
        $sidesSelect.on('change', function() {
            updateNumberOfSides(Number($(this).val()), function() {
                blockPoleChoices();
                updatePrice();
                updateDrawing();
                updateProductUi();
            });
        });
    }

    function updateSideInterfaceInput(sideConfiguration)
    {
        var sideId = sideConfiguration.id;
        var sideElement = $('.glassRailingSideSetting[data-side-number="' + sideId + '"]');

        sideElement.find('select.startPole').val(Number(sideConfiguration.startPartId));
        sideElement.find('select.endPole').val(Number(sideConfiguration.endPartId));
        sideElement.find('input.length').val(Number(sideConfiguration.length));

        $.each(sideConfiguration.pieces, function(length, quantity) {
            sideElement.find('.glassRailingSideSetting__lengths').find('[data-length="' + length + '"]').val(quantity);
        });
    }

    function updateSideConfigurationOnUi(sideConfiguration, callback)
    {
        var sideId = sideConfiguration.id;
        var sideElement = $('.glassRailingSideSetting[data-side-number="' + sideId + '"]');
        var length = Number(sideConfiguration.length);
        var startPole = Number(sideConfiguration.startPartId);
        var endPole = Number(sideConfiguration.endPartId);

        calculateClosestLength(length, startPole, endPole, function(closestAvailableLength) {
            sideElement.find('select.startPole').val(startPole);
            sideElement.find('select.endPole').val(endPole);
            sideElement.find('input.length').val(length);

            $.each(closestAvailableLength['pieces'], function(length, quantity) {
                sideElement.find('.glassRailingSideSetting__lengths').find('[data-length="' + length + '"]').val(quantity);
            });

            var index = configData.data[0].attributes.sidesConfiguration.sides.map(function(side) {
                return side.id;
            }).indexOf(sideId);

            configData.data[0].attributes.sidesConfiguration.sides[index].length = Number(closestAvailableLength['length']);
            configData.data[0].attributes.sidesConfiguration.sides[index].pieces = closestAvailableLength['pieces'];
            configData.data[0].attributes.sidesConfiguration.sides[index].sequence = closestAvailableLength['sequence'];

            if (callback) callback();
        }, sideConfiguration.pieces);
    }

    function updateSideConfiguration(
        sideId,
        startPartId,
        endPartId,
        length,
        pieces,
        sequence
    ) {
        const index = configData.data[0].attributes.sidesConfiguration.sides.map(function (side) {
            return side.id;
        }).indexOf(sideId);

        configData.data[0].attributes.sidesConfiguration.sides[index].startPartId = Number(startPartId);
        configData.data[0].attributes.sidesConfiguration.sides[index].endPartId = Number(endPartId);
        configData.data[0].attributes.sidesConfiguration.sides[index].length = Number(length);

        if (typeof pieces !== 'undefined') {
            configData.data[0].attributes.sidesConfiguration.sides[index].pieces = pieces;
        }
        if (typeof sequence !== 'undefined') {
            configData.data[0].attributes.sidesConfiguration.sides[index].sequence = sequence;
        }
    }

    function updateNumberOfSides(numberOfSides, callback)
    {
        var sideElementTemplate = $('.glassRailingSideSetting.--template');
        var currentlyVisibleSides = Number($('.glassRailingSideSetting').last().attr('data-side-number'));

        if (numberOfSides === currentlyVisibleSides) {
            if (callback) callback();
            return;
        }

        if (numberOfSides > currentlyVisibleSides) {
            function addNextSide(side) {
                if (side >= numberOfSides) {
                    if (callback) callback();
                    return;
                }
                var sideId = side + 1;
                var sideElement = sideElementTemplate.clone();

                if ($(`.glassRailingSideSetting[data-side-number="${sideId}"]`).length === 0) {
                    sideElement.attr('data-side-number', sideId);
                    sideElement.find('span.sideNumber').text(sideId);
                    sideElement.find('input.length').val(configData.data[0].attributes.defaultLength);

                    configData.data[0].attributes.availableLengths.forEach(function(length) {
                        var $optionWrapper = $('<div>')
                            .addClass('select-wrapper-config')
                            .addClass('configuratorHeader__productOptionsInputWrapper')
                            .append(
                                $('<label>')
                                    .text(length + ' mm')
                            )
                            .append(
                                $('<div>')
                                    .addClass('dimension-info-wrapper')
                                    .append(
                                        $('<select>')
                                            .addClass('configuratorHeader__productOptionsInput')
                                            .addClass('glassRailingLengthInput')
                                            .attr('data-length', length)
                                            .change(function(event) {
                                                const wrapper = $(this).closest('.configuratorHeader__productOptionsWrapper');
                                                const lengthInput = wrapper.find('input.length');
                                                const lengthSelectors = wrapper.find('.glassRailingLengthInput');
                                                const totalMargin = calculateMargin(
                                                    wrapper.find('select.startPole').val(),
                                                    wrapper.find('select.endPole').val(),
                                                );
                                                var totalLength = 0;

                                                lengthSelectors.each(function(index, element) {
                                                    const length = $(element).attr('data-length');
                                                    const quantity = $(element).val();

                                                    totalLength += length * quantity;
                                                });
                                                totalLength += totalMargin;
                                                lengthInput
                                                    .val(totalLength)
                                                    .blur();
                                            })
                                    )
                            );

                        for (let i = 0; i <= 20; i++) {
                            $optionWrapper.find('select').append($('<option>', {
                                value: i,
                                text: i
                            }));
                        }
                        sideElement.find('.glassRailingSideSetting__lengths').append($optionWrapper);
                    });
                    sideElement.removeClass('hidden');
                    sideElement.removeClass('--template');

                    if (sideId !== 1) {
                        sideElement.find('select.startPole').parent().parent().remove();
                    }

                    // The selected panels are the source of truth: a pole change only changes the margin,
                    // so recompute the side length from the panel selectors instead of reusing the old one
                    sideElement.find('select.startPole').on('change', function(event) {
                        sideElement.find('.glassRailingLengthInput').first().trigger('change');
                    });
                    sideElement.find('select.endPole').on('change', function(event) {
                        sideElement.find('.glassRailingLengthInput').first().trigger('change');
                    });
                    sideElement.find('input.length').on('blur', function(event) {
                        var userLength = Number(sideElement.find('input.length').val());
                        var startPole = sideElement.find('select.startPole').val();
                        var endPole = sideElement.find('select.endPole').val();
                        calculateClosestLength(userLength, startPole, endPole, function(closestAvailableLength) {
                            if (closestAvailableLength['length'] !== userLength) {
                                sideElement.find('input.length').val(closestAvailableLength['length']);
                            }
                            updateSideConfiguration(sideId, startPole, endPole, closestAvailableLength['length'], closestAvailableLength['pieces'], closestAvailableLength['sequence']);
                            updatePrice();
                            updateDrawing();
                            updateProductUi();
                        }, getSelectedSections(sideElement));
                    });
                    $('.glassRailingSides').append(sideElement);

                    if (typeof configData.data[0].attributes.sidesConfiguration.sides[side] === 'undefined') {
                        var userSelectedLength = Number(sideElement.find('input.length').val());
                        var startPole = Number(sideElement.find('select.startPole').val());
                        var endPole = Number(sideElement.find('select.endPole').val());
                        calculateClosestLength(userSelectedLength, startPole, endPole, function(closestAvailableLength) {
                            const sideObject = {
                                'id': sideId,
                                'startPartId': startPole,
                                'endPartId': endPole,
                                'length': closestAvailableLength['length'],
                                'pieces': closestAvailableLength['pieces'],
                                'sequence': closestAvailableLength['sequence'],
                            };
                            configData.data[0].attributes.sidesConfiguration.sides.push(sideObject);
                            addNextSide(side + 1);
                            updateSideInterfaceInput(sideObject);
                        });
                        return;
                    }
                }
                addNextSide(side + 1);
            }
            addNextSide(currentlyVisibleSides);
            return;
        }

        if (numberOfSides < currentlyVisibleSides) {
            $('.glassRailingSides .glassRailingSideSetting').each(function(index, element) {
                var sideNumber = Number($(element).attr('data-side-number'));

                if (sideNumber > numberOfSides) {
                    $(element).remove();

                    configData.data[0].attributes.sidesConfiguration.sides.length = numberOfSides;
                }
            });
            if (callback) callback();
        }

    }

    function populateAccessories()
    {
        $accessoriesList.parent().parent().removeClass('--hidden');

        configData.included.accessory.forEach(function(accessory) {
            var wrapperElement = $accessoriesList.find('.subProductAdditionalItems .subProductItem__content');

            let accessoryBox =
                $('<div>')
                .addClass('configuratorOptionCheckboxListingItem')
                .attr('data-id', accessory.id)
                .attr('data-is-default', Number(accessory.attributes.isDefault))
                .attr('data-is-stock', Number(accessory.attributes.isStock))
                .attr('data-quantity', 99999)
                // .attr('data-quantity', Number(accessory.attributes.warehouseStockAmount))
                .attr('data-img-src', accessory.attributes.imgSrc)
                .append(
                    $('<div>')
                    .addClass('configuratorOptionCheckboxListingItem__checkbox')
                )
                .append(
                    $('<div>')
                    .addClass('configuratorOptionCheckboxListingItem__name')
                    .text(accessory.attributes.name)
                    .attr('title', accessory.attributes.name)
                )
                .append(
                    $('<div>')
                    .addClass('configuratorOptionCheckboxListingItem__price')
                    .append(
                        $('<span>')
                        .attr('data-id', accessory.id)
                        .text('')
                    )
                )
                .append(
                    $('<span>')
                    .addClass('configuratorOptionCheckboxListingItem__info-btn')
                    .attr('data-id', accessory.id)
                    .text('i')
                );
            wrapperElement.parent().removeClass('hidden');
            wrapperElement.append(accessoryBox);
        });
        $accessoriesList.removeClass('hidden');

        $('.configuratorOptionCheckboxListingItem__info-btn').click(function() {
            const dataId = $(this).data('id');
            const element = $('#simpleConfiguratorAccessories2').find('div[data-id=' + dataId + ']');
            const name = element.find('.configuratorOptionCheckboxListingItem__name').text();
            const modal = $('#accessoryDetailsModal');
            const imgSrc = element.data('img-src');

            modal.find('.configuratorModal__title').text(name);
            modal.find('.modalContent').text(name);
            modal.find('.modalImg').attr('src', imgSrc);
            modal.removeClass('--hiddenTemplateElement');
        });

        populateAccessoriesPreview();
    }

    function populateAccessoriesPreview()
    {
        const previewContent = $accessoriesList.parent().parent().find('.configuratorPanel__preview-content');
        previewContent.html('');

        if ($('.configuratorOptionCheckboxListingItem.--checked-item').length > 0) {
            $('.configuratorOptionCheckboxListingItem.--checked-item').each(function(index, element) {
                previewContent.append(
                    $('<p>').text(
                        $(element).find('.configuratorOptionCheckboxListingItem__name').text()
                    )
                );
            });
        } else {
            previewContent.append(
                $('<p>').text('Ingår')
            );
        }
    }

    function buildDrawingConfig()
    {
        var currentSectionDirection = 'none';
        var regularColumnShape = null;
        const attributes = configData.data[0].attributes;
        var config = {
            handrail: hasHandRailEnabled(),
            sides: [],
            wallMountAllowance: WALL_FIXTURE_MARGIN_IN_MM,
            showHeightDimensions: Boolean(attributes.showHeightDimensions),
        }
        // 0 = height not filled in for the product; the drawing library then uses its own default
        if (Number(attributes.heightWithHandRail) > 0) {
            config.heightWithHandrail = Number(attributes.heightWithHandRail);
        }
        if (Number(attributes.heightWithoutHandRail) > 0) {
            config.heightWithoutHandrail = Number(attributes.heightWithoutHandRail);
        }
        if (configData.data[0].attributes.isStainlessSteelRailing) {
            regularColumnShape = 'round';
        } else {
            regularColumnShape = 'square';
        }
        configData.data[0].attributes.sidesConfiguration.sides.forEach(function(railingSide) {
            const startPole = getIncluded('poleTypes', railingSide.startPartId);
            const endPole = getIncluded('poleTypes', railingSide.endPartId);
            var startPoleType = regularColumnShape;
            var endPoleType = regularColumnShape;

            if (startPole !== null && startPole.attributes.typeId === TYPE_WALL_FIXTURE_GLASS_ID) {
                startPoleType = 'start';
            }
            if (endPole !== null && endPole.attributes.typeId === TYPE_WALL_FIXTURE_GLASS_ID) {
                endPoleType = 'end';
            }
            var currentSectionConfig = {
                direction: currentSectionDirection,
                columns: [
                    {
                        distance: 0,
                        type: startPoleType
                    },
                ],
            };
            const panelSequence = (railingSide.sequence && railingSide.sequence.length > 0)
                ? railingSide.sequence
                : Object.entries(railingSide.pieces).flatMap(([length, qty]) => Array(qty).fill(Number(length)));
            // Same formula that produces side.length; side.length itself may still hold the raw user input
            currentSectionConfig.totalLength = panelSequence.reduce((sum, length) => sum + Number(length), 0)
                + calculateMargin(railingSide.startPartId, railingSide.endPartId);
            for (const length of panelSequence) {
                currentSectionConfig.columns.push({
                    distance: length,
                    type: regularColumnShape,
                });
            }
            currentSectionConfig.columns[currentSectionConfig.columns.length - 1].type = endPoleType;

            if (endPole !== null && endPole.attributes.typeId === TYPE_POLE_CORNER_ID) {
                currentSectionDirection = 'left';
            } else {
                currentSectionDirection = 'none';
            }
            config.sides.push(currentSectionConfig);
        });

        return config;
    }

    function updateDrawing()
    {
        $('#icc-balustrada-container').html('');
        $('#icc-balustrada-topview-container').html('');

        const drawingConfig = buildDrawingConfig();
        let cameraAngle = 30;
        let rotateAngle = 15;

        if (drawingConfig.sides.length === 3) {
            cameraAngle = 30;
            rotateAngle = 75;
        }
        console.log('Drawing config:', drawingConfig);
        
        IccBalustrada.draw(
            {
                width: '100%',
                height: 500,
                containerId: 'icc-balustrada-container',
                'cameraAngle': cameraAngle,
                'rotateAngle': rotateAngle,
            },
            drawingConfig
        );
        IccBalustrada.draw(
            {
                width: '100%',
                height: 500,
                containerId: 'icc-balustrada-topview-container',
                'cameraAngle': 90,
                'rotateAngle': 0.1,
            },
            // A vertical dimension collapses into a point in the top view
            { ...drawingConfig, showHeightDimensions: false }
        );
    }

    function updatePrice()
    {
        configData._csrfToken = $('meta[name="csrfToken"]').attr('content');

        $.ajax({
            url: apiUrl + '/calculate-product-price',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify(configData),
            success: function(response) {
                if (response.meta.success) {
                    var userInputQuantity = $quantity.val();
                    var quantity = userInputQuantity;

                    if (configData.included.priceM) {
                        $priceUnit.text('kr/lpm');
                    } else {
                        $priceUnit.text(configData.productInfo.priceUnit);
                    }
                    price = response.data[0].price;
                    regularCustomerPrice = response.data[0].regularCustomerPrice;
                    netPrice = response.data[0].netPrice;
                    discount = response.data[0].discount;
                    discountValueForRegularCustomer = response.data[0].discountValueForRegularCustomer;
                    netDiscount = response.data[0].netDiscount;
                    discountValue = response.data[0].lineDiscountValue;

                    $item.text((price - discount));
                    $total.text(formatPrice((price - discount) * quantity));
                    $totalWithoutTax.text(formatPrice((netPrice - netDiscount) * quantity));
                    $ordinary.text(formatPrice(price));
                    $ordinaryItem = price;
                    $regularDiscount.text(formatPrice(discountValueForRegularCustomer * quantity));
                    $regularOrdinary.text(formatPrice((regularCustomerPrice + discountValueForRegularCustomer) * quantity));

                    if (discount <= 0) {
                        $discount.parents('.ordinary-price').hide();
                        $('[data-price="ordinary"]').parents('.ordinary-price').hide();
                        $('[data-price="regular-ordinary"]').parents('.ordinary-price').hide();
                        $('[data-price="regular-discount"]').parents('.ordinary-price').hide();
                    }
                    if (regularCustomerPrice !== 0) {
                        $totalForRegularCustomer.text(formatPrice((regularCustomerPrice - discountValueForRegularCustomer) * quantity));
                    } else {
                        $('.regular-customer-price').hide();
                    }
                    finalDiscount = discount;

                    if (finalDiscount > 0) {
                        $discount.text(formatPrice(finalDiscount));
                        $discountValue.text(discountValue);
                        $('.discount-info').show();
                    } else {
                        $('.discount-info').hide();
                    }
                    getPrice = true;

                    if (!locks.stock) {
                        $buyButton.removeAttr('disabled');
                    }
                }
            }
        });
    }

    /**
     * @todo: move to common file
     */
    function formatPrice(value)
    {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    $miniCartQuantity.on('input', function() {
        $quantity.val($miniCartQuantity.val());
        $quantity.trigger('input');
    });

    $('.addedToBasketPopup__continueShopping').on('click', function() {
        $('.addedToBasketPopup').removeClass('--visible');
    })

    $('.glassRailingConfigurator__unbalancedWarningPopup__close').on('click', function() {
        hideGlassRailingUnbalancedWarning();
    });

    $('.glassRailingConfigurator__unbalancedWarningPopup__continue').on('click', function() {
        hideGlassRailingUnbalancedWarning();
        saveProduct(true);
    });

    $quantity.on('input', function() {
        const quantity = $quantity.val();

        if (configData.data) {
            configData.data[0].attributes.quantity = quantity;
        } else {
            console.error('Cannot change quantity, product configuration is not initialized yet');
        }
        updatePrice();
        updateDrawing();
        updateProductUi();

        $miniCartQuantity.val(quantity);
    });

    function getAddToCartGTMEvent()
    {
        let productPrice = price - discount;

        googleTagManagerService.pushAddToCartDataLayer(
            productPrice,
            configData.data[0].attributes.articleNumber,
            configData.productInfo.configurationName,
            configData.productInfo.productCategory,
            $quantity.val()
        );
    }

    function enable3DView()
    {
        $('.configurator__button3d').addClass('--active');
        $('.configurator__buttonTopside').removeClass('--active');
        $('#icc-balustrada-container').removeClass('hide');
        $('#icc-balustrada-topview-container').addClass('hide');
    }

    function enableTopsideView()
    {
        $('.configurator__button3d').removeClass('--active');
        $('.configurator__buttonTopside').addClass('--active');
        $('#icc-balustrada-container').addClass('hide');
        $('#icc-balustrada-topview-container').removeClass('hide');
    }

    /**
     * Update the product UI with the latest configuration data, 
     * such as side lengths and other relevant information.
     */
    function updateProductUi()
    {
        const sidesConfiguration = configData.data[0].attributes.sidesConfiguration;

        sidesConfiguration.sides.forEach(function(side) {
            $(`.glassRailingSideSetting[data-side-number="${side.id}"]`)
                .find('[data-field-name="glassRailingSideTotalLength"]')
                .text(side.length);
        });

        populateAccessoriesPreview();
    }

    $('.configurator__button3d').on('click', function() {
        enable3DView();
    });

    $('.configurator__buttonTopside').on('click', function() {
        enableTopsideView();
    });

    /**
     * Add to cart events
     */
    $configurator.find('[data-submit]').on('click', function(event) {
        event.preventDefault();
        saveProduct();
    });

    $addToCartBottom.find('[data-submit]').on('click', function(event) {
        event.preventDefault();
        saveProduct();
    });

    /**
     * Get product object from api
     */
    getConfig();
    enable3DView();
});
